import '../../style/index.less';
import './index.less';

// style dependencies
import '../../checkbox/style';
